import { render, staticRenderFns } from "./LegendLayersListStyles.vue?vue&type=template&id=b358c46a&scoped=true&"
import script from "./LegendLayersListStyles.vue?vue&type=script&lang=js&"
export * from "./LegendLayersListStyles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b358c46a",
  null
  
)

export default component.exports